import { render, staticRenderFns } from "./data84.vue?vue&type=template&id=548e3391&scoped=true"
import script from "./data84.vue?vue&type=script&lang=js"
export * from "./data84.vue?vue&type=script&lang=js"
import style1 from "./data84.vue?vue&type=style&index=1&id=548e3391&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548e3391",
  null
  
)

export default component.exports